module.exports = __webpack_public_path__ + "img/image14.0bc1d693.png";